const apiEndPoints = require("../apiendpoints/index");
const url = "http://restapi.adequateshop.com/api";

module.exports.config = {
  APIUrl: url,
  api: apiEndPoints.api,
};
